module.exports = __webpack_public_path__ + "img/13.63f4dac8.jpg";